import {
  getActiveTemplate,
  getClientJourney,
  getClientOverview,
  getIndicators,
  getClientsJourneySummary,
  markStep as markStepService,
} from '@modules/client-journey/services/journey-service'

const MSG_ERRO =
  'Não foi possível carregar a jornada do cliente. Tente novamente mais tarde.'

export default {
  // ATENCAO: try/catch AQUI, e não em cada chamador. O perfil e a página de
  // resumo envolviam a chamada em `try/finally` sem `catch`; uma falha do
  // template virava unhandled rejection e, no resumo, `abrirPassoDaQuery()`
  // nunca rodava — o passo vindo por `?passo=` não abria.
  async carregarTemplate({ commit, state }) {
    if (state.template) return state.template
    try {
      const template = await getActiveTemplate()
      commit('SET_TEMPLATE', template)
      return template
    } catch {
      commit('SET_ERROR', MSG_ERRO)
      return null
    }
  },

  async carregarCliente({ commit }, clientId) {
    if (!clientId) return null
    commit('SET_LOADING', true)
    commit('SET_ERROR', null)
    try {
      const journey = await getClientJourney(clientId)
      commit('SET_JOURNEY', journey)
      return journey
    } catch {
      commit('SET_ERROR', MSG_ERRO)
      return null
    } finally {
      commit('SET_LOADING', false)
    }
  },

  // Carga separada da jornada: os cards 360 e a timeline falham de forma
  // independente — perder o resumo não pode apagar a jornada da tela.
  async carregarOverview({ commit }, clientId) {
    if (!clientId) return null
    try {
      const overview = await getClientOverview(clientId)
      commit('SET_OVERVIEW', overview)
      return overview
    } catch {
      return null
    }
  },

  // A listagem chama isto DEPOIS de já ter renderizado os clientes: a coluna
  // preenche progressivamente em vez de segurar a tabela inteira.
  async carregarResumos({ commit }, clientIds) {
    const ids = Array.isArray(clientIds) ? clientIds : []
    if (!ids.length) return []
    commit('SET_LOADING_SUMMARIES', true)
    try {
      const summaries = await getClientsJourneySummary(ids)
      commit('SET_SUMMARIES', summaries)
      return summaries
    } catch {
      // Falha aqui degrada a coluna Jornada para vazia — nunca derruba a lista
      // de clientes, que é a função principal da tela.
      commit('SET_ERROR', MSG_ERRO)
      return []
    } finally {
      commit('SET_LOADING_SUMMARIES', false)
    }
  },

  // Chamada pela listagem DEPOIS dos resumos: o backend conta a carteira
  // inteira, o cálculo local só a página visível.
  async carregarIndicadores({ commit, getters }) {
    try {
      const indicadores = await getIndicators(getters.summaries)
      commit('SET_INDICATORS', indicadores)
      return indicadores
    } catch {
      // Sem indicadores do backend a faixa cai no fallback local — nunca fica
      // vazia nem derruba a listagem.
      return null
    }
  },

  // Update otimista com rollback: o passo é clicável na timeline e a resposta
  // precisa ser imediata; se o servidor recusar, o estado anterior volta.
  async concluirPasso({ commit, state }, { clientId, stepId, done = true }) {
    const anterior = state.byClientId[clientId]
    if (anterior) {
      commit('SET_JOURNEY', {
        ...anterior,
        stages: anterior.stages.map((stage) => ({
          ...stage,
          steps: stage.steps.map((step) =>
            step.stepId === stepId
              ? { ...step, status: done ? 'concluida' : 'pendente' }
              : step
          ),
        })),
      })
    }

    try {
      const journey = await markStepService(clientId, stepId, done)
      if (journey) commit('SET_JOURNEY', journey)
      return journey
    } catch {
      if (anterior) commit('SET_JOURNEY', anterior)
      commit('SET_ERROR', MSG_ERRO)
      return null
    }
  },
}
